// extracted by mini-css-extract-plugin
export default {"container":"styles_container__P-pHL","label":"styles_label__4mrtC","textArea":"styles_textArea__OSDly","errorInput":"styles_errorInput__RLQyL","errorText":"styles_errorText__Fhpcu"};